export default "__VITE_ASSET__BrlboHha__"